class IuropInstagram extends HTMLElement {
  #events;
  #resize;
  #frame;
  connectedCallback() {
    this.#events?.abort();
    this.#events = new AbortController();
    const { signal } = this.#events;
    this.track = this.querySelector('[data-ig-track]');
    if (!this.track) return;
    this.previous = this.querySelector('[data-ig-prev]');
    this.next = this.querySelector('[data-ig-next]');
    this.controls = this.querySelector('[data-ig-controls]');
    this.progress = this.querySelector('[data-ig-progress]');
    this.previous?.addEventListener('click', () => this.move(-1), { signal });
    this.next?.addEventListener('click', () => this.move(1), { signal });
    this.track.addEventListener('scroll', () => this.update(), { passive: true, signal });
    this.track.addEventListener('keydown', event => {
      if (event.target !== this.track) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      }
    }, { signal });
    this.#resize?.disconnect();
    this.#resize = new ResizeObserver(() => this.update());
    this.#resize.observe(this.track);
    this.update();
  }
  disconnectedCallback() {
    this.#events?.abort();
    this.#resize?.disconnect();
    cancelAnimationFrame(this.#frame);
    this.#frame = null;
  }
  move(direction) {
    const width = this.track.firstElementChild?.getBoundingClientRect().width || 0;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const rtl = getComputedStyle(this.track).direction === 'rtl';
    this.track.scrollBy({ left: direction * (rtl ? -1 : 1) * (width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }
  update() {
    if (this.#frame) return;
    this.#frame = requestAnimationFrame(() => {
      this.#frame = null;
      const { scrollWidth, clientWidth, scrollLeft } = this.track;
      const max = Math.max(0, scrollWidth - clientWidth);
      const offset = Math.min(max, Math.abs(scrollLeft));
      if (this.controls) this.controls.hidden = max < 2;
      if (this.previous) this.previous.disabled = offset < 2;
      if (this.next) this.next.disabled = offset >= max - 2;
      this.progress?.style.setProperty('--ig-progress', String(scrollWidth ? Math.min(1, (clientWidth + offset) / scrollWidth) : 1));
    });
  }
}
if (!customElements.get('iurop-instagram')) customElements.define('iurop-instagram', IuropInstagram);
